module.exports = __webpack_public_path__ + "static/media/intersection.8e2c7256.svg";